import { Text } from 'foundations-components/components/Text';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { Link } from 'react-router-dom';
import { Paths } from '../../constants/paths';
import { useGates } from '../../hooks/useGates';
import { useCrossSearchCount } from '../hooks/useCrossSearchCount';
import { useSearchResultsQuery } from '../hooks/useSearchResultsQuery';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SearchResultsHeader() {
  var _data$result$total2;
  const searchParams = useSearchParams();
  const {
    data
  } = useSearchResultsQuery();
  const gates = useGates();
  const crossSearch = useCrossSearchCount();
  const search = searchParams.get('search');
  if (!search) return undefined;
  const showCrossLink = gates.solutionsSpringSpotlight && !gates.tabularSearch && (crossSearch.isProducts || crossSearch.isSolutions);
  if (showCrossLink) {
    var _data$result$total, _crossSearch$count;
    const otherPath = crossSearch.isProducts ? Paths.SEARCH_RESULTS_SOLUTIONS_PARTNERS : Paths.SEARCH_RESULTS_PRODUCTS;
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "200",
      paddingBlockEnd: "200",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h1",
        typography: "body-200",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: crossSearch.isProducts ? 'marketplaceStorefront.searchResults.header.resultsForQueryInApps_jsx' : 'marketplaceStorefront.searchResults.header.resultsForQueryInSolutions_jsx',
          elements: {
            Strong: props => /*#__PURE__*/_jsx(Text, Object.assign({
              as: "span",
              typography: "heading-100"
            }, props))
          },
          options: {
            count: (_data$result$total = data === null || data === void 0 ? void 0 : data.result.total) !== null && _data$result$total !== void 0 ? _data$result$total : 0,
            query: search
          }
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: "detail-100",
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: crossSearch.isProducts ? 'marketplaceStorefront.searchResults.header.crossSearchLinkToSolutions_jsx' : 'marketplaceStorefront.searchResults.header.crossSearchLinkToApps_jsx',
          elements: {
            Strong: props => /*#__PURE__*/_jsx(Text, Object.assign({
              as: "span",
              typography: "detail-100",
              fontWeight: "bold"
            }, props)),
            Link: props => /*#__PURE__*/_jsx(Link, Object.assign({
              to: `${otherPath}?eco_search=${encodeURIComponent(search)}`
            }, props))
          },
          options: {
            otherCount: (_crossSearch$count = crossSearch.count) !== null && _crossSearch$count !== void 0 ? _crossSearch$count : 0
          }
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(Text, {
    as: "h1",
    typography: "body-200",
    paddingBlock: "200",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "marketplaceStorefront.searchResults.header.resultsForQuery_jsx",
      elements: {
        Strong: props => /*#__PURE__*/_jsx(Text, Object.assign({
          as: "span",
          typography: "heading-100"
        }, props))
      },
      options: {
        count: (_data$result$total2 = data === null || data === void 0 ? void 0 : data.result.total) !== null && _data$result$total2 !== void 0 ? _data$result$total2 : 0,
        query: search
      }
    })
  });
}